import React from 'react';
import { Outlet } from 'react-router-dom';
import './index.scss';

// Logo 组件
const Logo: React.FC = () => (
  <div className="onboarding-logo">
    <img src="https://akoss.bangcdn.net/fe/leftLogo.svg" alt="Phoenix Music" />
  </div>
);

const OnboardingLayout: React.FC = () => {
  return (
    <div className="onboarding-layout">
      {/* 左侧 Logo 区域 */}
      <aside className="onboarding-sidebar">
        <Logo />
      </aside>

      {/* 主内容区 */}
      <main className="onboarding-content">
        <Outlet />
      </main>
    </div>
  );
};

export default OnboardingLayout;
